import { NOTES } from "../actionTypes";
import produce from 'immer';

const initialState = {
    arrMyNotes: [],
};

const notesReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case NOTES.GET_NOTES: {
            return {
                ...state,
                arrMyNotes: [
                    {
                        id: 1,
                        title: 'Untitled',
                        description: 'ONGC chart movement indicated Gap Up open',
                        categoryName: 'Oil & Gas',
                        subCategory: 'Crude Oil',
                        issueDate: '01:20 PM, 21 Apr 22'
                    },
                    {
                        id: 2,
                        title: 'TCS',
                        description: 'Nifty 50 around 18,100 level; IT stocks outperforming',
                        categoryName: 'IT Industry',
                        subCategory: null,
                        issueDate: '01:20 PM, 21 Feb 22'
                    },
                    {
                        id: 3,
                        title: null,
                        description: 'Share Market Today: Sensex, Nifty Close Lower;FPIs Stay Net Buyer',
                        categoryName: 'Nifty 50',
                        subCategory: 'Top 50',
                        issueDate: '01:20 PM, 21 Mar 22'
                    },
                    {
                        id: 4,
                        title: 'Untitled',
                        description: 'ONGC chart movement indicated Gap Up open',
                        categoryName: 'Oil & Gas',
                        subCategory: 'Crude Oil',
                        issueDate: '01:20 PM, 21 Apr 22'
                    }
                ]
            };
        }

        case NOTES.UPDATE_NOTES: {
            return produce(state, draftState => {
                draftState.arrMyNotes.push(actions.payload);

            });
        }

        default:
            return state;
    }
    // case GET_EXCHANGE_ANNOUNCEMENTS_SUCCESS: {
    //     return produce(state, draftState => {
    //         draftState.newsTypes[2].data = actions.payload;
    //         draftState.isAnnouncementsLoading = false;
    //     })
    // }

};
export default notesReducer;